import { render, staticRenderFns } from "./rocketProductManagement.vue?vue&type=template&id=0f9fa008&scoped=true"
import script from "./rocketProductManagement.vue?vue&type=script&lang=js"
export * from "./rocketProductManagement.vue?vue&type=script&lang=js"
import style0 from "./rocketProductManagement.vue?vue&type=style&index=0&id=0f9fa008&prod&scoped=true&lang=css"
import style1 from "./rocketProductManagement.vue?vue&type=style&index=1&id=0f9fa008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fa008",
  null
  
)

export default component.exports